import Providers from "providers";

function App() {
  return <Providers />;
}

export default App;
